import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestfulApiService } from '../restful-api.service';

/**
 * Payload for toggling watchlist (favorites)
 */
export interface ToggleWatchlistPayload {
  entityUUID: string;
  watchlistType: 'ADD' | 'REMOVE';
  fundType: 'ORGANISATION' | 'PROJECT';
}

/**
 * Response from toggle-watchlist API
 */
export interface ToggleWatchlistResponse {
  success: boolean;
  message?: string;
  data?: any;
}

@Injectable({
  providedIn: 'root',
})
export class CharityUserService {
  constructor(private restfulApiService: RestfulApiService) {}

  /**
   * Toggle watchlist (add/remove from favorites)
   * @param payload - The watchlist payload containing entityUUID, watchlistType, and fundType
   * @returns Observable of the API response
   */
  toggleWatchlist(payload: ToggleWatchlistPayload): Observable<ToggleWatchlistResponse> {
    return this.restfulApiService.post(`/v1/users/toggle-watchlist`, payload) as Observable<ToggleWatchlistResponse>;
  }
}
